import { Container } from '@material-ui/core';
import { fileInfoType } from 'api/file/interfaces/get-file';
import { KBLinks } from 'features/constants';
import React, { FC } from 'react';
import PageHeader from 'ui-kit/components/headers/PageHeader';
import LoadingSpinner from 'ui-kit/components/LoadingSpinner';
import ReportingPartyForm from './ReportingPartyForm';

interface ReportPartyInformationContentProps {
  fileData?: fileInfoType | null;
  menuCollapsed?: boolean;
  formSubmitted?: boolean;
  onFormSubmissionComplete?: () => void;
  isReadOnly?: boolean;
}

const ReportPartyInformationContent: FC<ReportPartyInformationContentProps> = (props) => {
  const { formSubmitted = false, onFormSubmissionComplete, isReadOnly = false } = props;

  return (
    <div
      style={{ pointerEvents: isReadOnly ? 'none' : 'auto', opacity: isReadOnly ? 0.6 : 1 }}
      tabIndex={isReadOnly ? -1 : undefined}
      onKeyDown={(e) => isReadOnly && e.preventDefault()}
    >
      <>
        <LoadingSpinner status={status} variant="linear" />
        <PageHeader
          title="Reporting Party Information"
          subtitle="The report must include information about the reporting party as determined according to 31 CFR 1031.320(c). Only one reporting person may be recorded."
          menuItems={[
            {
              label: 'Knowledge Base',
              link: KBLinks.fincenReport,
            },
          ]}
          data-testid="fincen-reporting-party-page-header"
        />

        <Container>
          <ReportingPartyForm submitted={formSubmitted} onFormSubmissionComplete={onFormSubmissionComplete} />
        </Container>
      </>
    </div>
  );
};
export default React.memo(ReportPartyInformationContent);
